//@ts-nocheck
import clsx from "clsx";
import * as React from "react";
import Atom from "../../atom";
import { PropsType } from "../@types/alert";

export default function Alert(props: PropsType) {
  const { message, type, onClose, className, ...other } = props;

  return (
    <Atom.Div
      className={clsx(`alert alert-dismissible alert-${type}`, className)}
      {...other}
    >
      <Atom.Button
        type="button"
        className="btn-close"
        onClick={() => onClose?.()}
      />
      <Atom.Strong>{message}</Atom.Strong>
    </Atom.Div>
  );
}
